import APIContext from 'contexts/base/APIContext'

export default class UsersContext extends APIContext{
  static contextName = 'users'
}
